export default "__VITE_ASSET__DDFoc5Fa__"